// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"2458004c","104":"df5ea317","142":"d0b04cc9","582":"605a4644","588":"d7b301f5","727":"977e4fcd","803":"10ace0dc","855":"b7ac779d","896":"b5df713e"}[chunkId] + ".chunk.js";
};